var _rect, _path, _path2, _path3, _path4, _rect2, _rect3, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSportsThumbnailGray = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-background",
    x: 0.5,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 10.5,
    fill: "#D5D8DD",
    stroke: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-podium",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 62C38.2386 62 36 64.2386 36 67V78H17C14.2386 78 12 80.2386 12 83V101H52H92V83C92 80.2386 89.7614 78 87 78H68V67C68 64.2386 65.7614 62 63 62H41Z",
    fill: "#67717E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6091 11.6843C35.91 11.6843 35.3433 12.2511 35.3433 12.9502C35.3433 13.6493 35.91 14.216 36.6091 14.216H38.8883V16.4444H32.8101C32.5916 16.4444 32.3823 16.5327 32.2298 16.6893C32.0773 16.8458 31.9945 17.0573 32.0003 17.2758C32.0445 18.9571 32.4253 21.506 33.4485 23.7143C34.4481 25.8718 36.1492 27.8679 38.8883 28.1709V30.9252C38.8883 30.9252 41.0534 37.6174 48.5076 39.2002V48.6048L41.1478 51.6713C40.3931 51.9858 39.9015 52.7232 39.9015 53.5409V59.7857C39.9015 60.9043 40.8082 61.811 41.9268 61.811H62.1802C63.2988 61.811 64.2055 60.9043 64.2055 59.7857V53.5409C64.2055 52.7232 63.7139 51.9858 62.9592 51.6713L55.0899 48.3925V39.2007C62.5458 37.6187 64.7114 30.9252 64.7114 30.9252V28.1705C67.4572 27.8581 69.1545 25.809 70.1495 23.6078C71.1704 21.3493 71.5505 18.742 71.5945 17.0227C71.6001 16.8043 71.5173 16.5929 71.3648 16.4365C71.2123 16.28 71.0031 16.1918 70.7847 16.1918H64.7114V14.216H67.4956C68.1947 14.216 68.7614 13.6493 68.7614 12.9502C68.7614 12.2511 68.1947 11.6843 67.4956 11.6843L36.6091 11.6843ZM38.8883 26.5369V18.0646H33.6678C33.7943 19.5305 34.1655 21.4076 34.9186 23.0332C35.7766 24.8849 37.0476 26.257 38.8883 26.5369ZM68.673 22.9404C67.8121 24.845 66.5406 26.2469 64.7114 26.5356V17.812H69.9288C69.8039 19.3215 69.432 21.2614 68.673 22.9404Z",
    fill: "#9DA4AF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-trophy",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6091 11.6843C35.91 11.6843 35.3433 12.2511 35.3433 12.9502C35.3433 13.6493 35.91 14.216 36.6091 14.216H38.8883V16.4444H32.8101C32.5916 16.4444 32.3823 16.5327 32.2298 16.6893C32.0773 16.8458 31.9945 17.0573 32.0003 17.2758C32.0445 18.9571 32.4253 21.506 33.4485 23.7143C34.4481 25.8718 36.1492 27.8679 38.8883 28.1709V30.9252C38.8883 30.9252 41.0534 37.6174 48.5076 39.2002V48.6048L41.1478 51.6713C40.3931 51.9858 39.9015 52.7232 39.9015 53.5409V59.7857C39.9015 60.9043 40.8082 61.811 41.9268 61.811H62.1802C63.2988 61.811 64.2055 60.9043 64.2055 59.7857V53.5409C64.2055 52.7232 63.7139 51.9858 62.9592 51.6713L55.0899 48.3925V39.2007C62.5458 37.6187 64.7114 30.9252 64.7114 30.9252V28.1705C67.4572 27.8581 69.1545 25.809 70.1495 23.6078C71.1704 21.3493 71.5505 18.742 71.5945 17.0227C71.6001 16.8043 71.5173 16.5929 71.3648 16.4365C71.2123 16.28 71.0031 16.1918 70.7847 16.1918H64.7114V14.216H67.4956C68.1947 14.216 68.7614 13.6493 68.7614 12.9502C68.7614 12.2511 68.1947 11.6843 67.4956 11.6843L36.6091 11.6843ZM38.8883 26.5369V18.0646H33.6678C33.7943 19.5305 34.1655 21.4076 34.9186 23.0332C35.7766 24.8849 37.0476 26.257 38.8883 26.5369ZM68.673 22.9404C67.8121 24.845 66.5406 26.2469 64.7114 26.5356V17.812H69.9288C69.8039 19.3215 69.432 21.2614 68.673 22.9404Z",
    fill: "#9DA4AF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-trophy-shadow",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9887 11.6853V29.9136C47.3262 31.3482 48.6596 34.42 51.2925 35.2301V50.167C49.2672 51.2641 45.2165 53.6607 45.2165 54.4709V61.812H41.9243C40.8058 61.812 39.899 60.9052 39.899 59.7867V53.5418C39.899 52.7242 40.3906 51.9868 41.1454 51.6723L48.5076 48.6047V39.2017C41.0514 37.6198 38.8858 30.9262 38.8858 30.9262V28.1716C36.1482 27.8677 34.4478 25.8722 33.4485 23.7153C32.4253 21.5069 32.0445 18.9581 32.0003 17.2768C31.9945 17.0583 32.0773 16.8468 32.2298 16.6902C32.3823 16.5337 32.5916 16.4454 32.8101 16.4454H38.8858V14.217H36.6091C35.91 14.217 35.3433 13.6502 35.3433 12.9511C35.3433 12.252 35.91 11.6853 36.6091 11.6853H46.9887ZM38.8858 18.0656V26.5375C37.0465 26.2567 35.7762 24.885 34.9186 23.0342C34.1655 21.4086 33.7943 19.5314 33.6678 18.0656H38.8858Z",
    fill: "#818A98"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-medal-ribbon",
    x: 54.9902,
    y: 11,
    width: 6.03224,
    height: 13.8742,
    rx: 0.482572,
    fill: "#D5D8DD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-medal-ribbon-stripe",
    x: 56.8008,
    y: 11,
    width: 2.4129,
    height: 13.8742,
    fill: "#818A98"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-medal",
    d: "M57.5473 19.6518C57.6918 19.2072 58.3208 19.2072 58.4652 19.6518L59.5231 22.9076C59.5877 23.1065 59.773 23.2411 59.9821 23.2411L63.4055 23.2411C63.873 23.2411 64.0673 23.8393 63.6891 24.1141L60.9195 26.1263C60.7504 26.2492 60.6796 26.467 60.7442 26.6658L61.8021 29.9217C61.9466 30.3663 61.4377 30.736 61.0595 30.4612L58.2899 28.449C58.1208 28.3261 57.8918 28.3261 57.7226 28.449L54.953 30.4612C54.5748 30.736 54.066 30.3663 54.2104 29.9217L55.2683 26.6658C55.3329 26.467 55.2621 26.2492 55.093 26.1263L52.3234 24.1141C51.9452 23.8393 52.1396 23.2411 52.6071 23.2411L56.0305 23.2411C56.2395 23.2411 56.4248 23.1065 56.4894 22.9076L57.5473 19.6518Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-podium-circles",
    cx: 52.5,
    cy: 70.5,
    r: 3.5,
    fill: "#D5D8DD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-podium-circles",
    cx: 23.5,
    cy: 87.5,
    r: 3.5,
    fill: "#D5D8DD"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-podium-circles",
    cx: 77.5,
    cy: 87.5,
    r: 3.5,
    fill: "#D5D8DD"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-podium-circles",
    cx: 70.5,
    cy: 87.5,
    r: 3.5,
    fill: "#D5D8DD"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-podium-circles",
    cx: 30.5,
    cy: 87.5,
    r: 3.5,
    fill: "#D5D8DD"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-podium-circles",
    cx: 84.5,
    cy: 87.5,
    r: 3.5,
    fill: "#D5D8DD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSportsThumbnailGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SportsThumbnailGray.ac16d58753ec594aeae8a5142f7aae15.svg";